import { Routes } from '@angular/router';
import { PageNotFoundComponent } from '../../libs/page-not-found/page-not-found.component';
import { EmaBatchHeadersComponent } from './studioema/ema-batch-headers/ema-batch-headers.component';
import { EmaBatchViewComponent } from './studioema/ema-batch-view/ema-batch-view.component';
import { ssoAuthGuard } from './services/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'batch-headers', pathMatch: 'full' },
  { path: 'batch-headers', component: EmaBatchHeadersComponent, canActivate: [ssoAuthGuard] },
  { path: 'partner/:name', component: EmaBatchHeadersComponent, canActivate: [ssoAuthGuard] },
  { path: 'batch/:batchId', component: EmaBatchViewComponent, canActivate: [ssoAuthGuard] },
  { path: '**', component: PageNotFoundComponent },
];
